import {
  Object3D,
  Euler,
  Vector3,
  Vector2,
  CircleGeometry,
  MeshBasicMaterial,
  Mesh,
  DoubleSide,
} from "three";
import { BasePanel } from "./BasePanel.js";
import Util from "../utils/utils.js";
import { VGridLayout } from "../VUILib/UILayout/VLayout.js";

const btn_normalPath = "/assets/vrUI/common/btn_normal.png";
const btn_hoverPath = "/assets/vrUI/common/btn_hover.png";
const btn_clickPath = "/assets/vrUI/common/btn_click.png";
const defaultMatIconPath = "/assets/imgs/defaultMat.jpg";
const dropdownBgPath = "/assets/vrUI/EditPanel_Model/dropdownBg.png";
const dropdownItemBgPath = "/assets/vrUI/EditPanel_Model/dropdownItemBg.png";
const searchIconPath = "/assets/vrUI/EditPanel_Model/searchIcon.png";

const openToggleIconPath = "/assets/vrUI/EditPanel_Model/open.png";
const closeToggleIconPath = "/assets/vrUI/EditPanel_Model/close.png";
const backIconPath = "/assets/vrUI/EditPanel_Model/backIcon.png";

const matrixIconPath = "/assets/vrUI/EditPanel_Model/matrixIcon.png";
const curveIconPath = "/assets/vrUI/EditPanel_Model/curveIcon.png";

export class EditPanel_Model extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
  }

  init() {}

  async initPanel(parent) {
    this.parent = parent;

    this.width = 2.175;
    this.height = 0.7;
    this.container = this.uilib.createContainer({
      opacity: 0,
      width: this.width,
      height: this.height,
      radius: 0,
      dragable: false,
    });
    this.parent.add(this.container);
    this.uiElements.push(this.container);
    this.container.visible = this._visible;

    this.currentSelectData = null; // 当前选中的模型数据

    this.randomEnable = false; // 是否随机
    this.modelEditTypy = "matrix"; // 模型编辑类型 matrix/curve

    this.clickCatalogStack = [];

    this.defaultIcon = await this.manager.loadManager.loadTexture(
      defaultMatIconPath
    );
    const dropdownBg = await this.manager.loadManager.loadTexture(
      dropdownBgPath
    );
    const itemBg = await this.manager.loadManager.loadTexture(
      dropdownItemBgPath
    );
    const searchIcon = await this.manager.loadManager.loadTexture(
      searchIconPath
    );

    const btn_normal = await this.manager.loadManager.loadTexture(
      btn_normalPath
    );
    const btn_hover = await this.manager.loadManager.loadTexture(btn_hoverPath);
    const btn_click = await this.manager.loadManager.loadTexture(btn_clickPath);
    const backIcon = await this.manager.loadManager.loadTexture(backIconPath);

    // 选中模型部分
    {
      const container2 = this.uilib.createContainer({
        opacity: 0.5,
        width: 0.4,
        height: 0.5,
        color: 0x4f5670,
        radius: 0.05,
        dragable: false,
      });
      this.container.add(container2);
      container2.position.x = -0.85;
      container2.position.y = -0.05;
      container2.position.z = 0.001;
      // snap
      this.selectIcon = this.uilib.createImage({
        map: this.defaultIcon,
        width: 0.35,
        height: 0.35,
        radius: 0.05,
        color: 0xffffff,
      });
      container2.add(this.selectIcon);
      this.selectIcon.position.y = 0.05;
      this.selectIcon.position.z = 0.001;
      // 模型名称
      this.setSelectModelName("");
    }

    // 模型编辑
    {
      const text1 = this.uilib.createText({
        text: "模型编辑",
        textColor: 0xafbbe3,
        font: "bold",
        textSize: 0.05,
      });
      this.container.add(text1);
      text1.position.x = -0.95;
      text1.position.y = 0.275;
    }

    // 模型精度
    {
      const text2 = this.uilib.createText({
        text: "模型精度",
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "left",
      });
      this.container.add(text2);
      text2.position.y = 0.275;
      text2.position.x = -0.6;

      this.modelPrecision = "中";
      const dropdown = this.uilib.createDropdown({
        options: ["高", "中", "低"],
        defaultIndex:
          this.modelPrecision === "高"
            ? 0
            : this.modelPrecision === "中"
            ? 1
            : 2,
        map: dropdownBg,
        textSize: 0.04,
        textColor: 0xafbbe3,
        iconColor: 0xffffff,
        width: 0.2,
        height: 0.1,
        itemBgMap: itemBg,
        bgOpacity: 0,
        radius: 0.02,
        stateChangeColor: {
          normal: 0xffffff,
          hover: 0xafbbe3,
          click: 0x8993c3,
        },
        itemColor: 0xffffff,
        optionStageChangeColor: {
          normal: 0xffffff,
          hover: 0xafbbe3,
        },
      });
      dropdown.addOnValueChangeEvent((index, str) => {
        if (this.modelPrecision !== str) {
          this.modelPrecision = str;
        }
      });
      this.container.add(dropdown);

      dropdown.position.x = -0.3;
      dropdown.position.z = 0.001;
      dropdown.position.y = 0.275;
    }

    // 竖线
    {
      const line = this.uilib.createContainer({
        width: 0.005,
        height: 0.6,
        color: 0xa8b4db,
        radius: 0,
        opacity: 0.5,
      });
      this.container.add(line);
      line.position.x = 0.0;
    }

    // 阵列ui
    {
      const texts = ["行数", "列数", "间隔"];
      this.uis1 = [];
      this.matrixInputfileds = [];
      for (var i = 0; i < texts.length; i++) {
        const text = this.uilib.createText({
          text: texts[i],
          textColor: 0xafbbe3,
          textSize: 0.04,
          font: "bold",
          font: "normal",
          align: "left",
        });
        this.container.add(text);
        text.position.y = this.height / 2 - i * 0.12 - 0.2;
        text.position.x = -0.6;
        if (this.modelEditTypy !== "matrix") text.visible = false;
        this.uis1.push(text);

        const inputfield = this.uilib.createInputField({
          width: 0.25,
          height: 0.1,
          radius: 0.02,
          color: 0x4f5670,
          text: "1",
          textColor: 0xa8b4db,
          opacity: 0.5,
          textSize: 0.04,
          font: "normal",
          align: "left",
          contentType: i === 2 ? "DecimalNumber" : "IntegerNumber",
          stateChangeColor: {
            normal: 0x4f5670,
            hover: 0xffffff,
          },
        });
        inputfield._InputFieldIndex = i;
        inputfield.addOnValueChangeEvent(() => {
          this.updateMatrixArgs();
        });
        this.container.add(inputfield);
        inputfield.position.z = 0.001;
        inputfield.position.y = this.height / 2 - i * 0.12 - 0.2;
        inputfield.position.x = -0.35;
        if (this.modelEditTypy !== "matrix") inputfield.visible = false;
        this.matrixInputfileds.push(inputfield);
        this.uis1.push(inputfield);
      }
    }

    // 曲线ui
    {
      this.uis2 = [];
      const text = this.uilib.createText({
        text: "间距",
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "left",
      });
      this.container.add(text);
      text.position.y = this.height / 2 - 0.2;
      text.position.x = -0.6;
      this.uis2.push(text);
      if (this.modelEditTypy !== "curve") text.visible = false;

      const inputfield = this.uilib.createInputField({
        width: 0.25,
        height: 0.1,
        radius: 0.02,
        color: 0x4f5670,
        text: "1",
        textColor: 0xa8b4db,
        opacity: 0.5,
        textSize: 0.04,
        font: "normal",
        align: "left",
        contentType: "DecimalNumber",
        stateChangeColor: {
          normal: 0x4f5670,
          hover: 0xffffff,
        },
      });
      this.container.add(inputfield);
      inputfield.addOnValueChangeEvent(() => {
        this.updateCurveArgs();
      });
      inputfield.position.z = 0.001;
      inputfield.position.y = this.height / 2 - 0.2;
      inputfield.position.x = -0.35;
      if (this.modelEditTypy !== "curve") inputfield.visible = false;
      this.uis2.push(inputfield);
      this.curveInputfiled = inputfield;

      const text2 = this.uilib.createText({
        text: "类型",
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "left",
      });
      this.container.add(text2);
      text2.position.y = this.height / 2 - 0.32;
      text2.position.x = -0.6;
      this.uis2.push(text2);
      if (this.modelEditTypy !== "curve") text2.visible = false;

      this.curveType = "curve";
      const dropdown = this.uilib.createDropdown({
        options: ["曲线", "直线"],
        defaultIndex: 0,
        map: dropdownBg,
        textSize: 0.04,
        textColor: 0xafbbe3,
        iconColor: 0xffffff,
        width: 0.25,
        height: 0.1,
        itemBgMap: itemBg,
        bgOpacity: 0,
        radius: 0.02,
        stateChangeColor: {
          normal: 0xffffff,
          hover: 0xafbbe3,
          click: 0x8993c3,
        },
        itemColor: 0xffffff,
        optionStageChangeColor: {
          normal: 0xffffff,
          hover: 0xafbbe3,
        },
      });
      dropdown.addOnValueChangeEvent((index, str) => {
        const type = index === 0 ? "curve" : "line";
        if (this.curveType !== type) {
          this.curveType = type;
          this.updateCurveArgs();
        }
      });
      this.container.add(dropdown);
      this.uis2.push(dropdown);
      if (this.modelEditTypy !== "curve") dropdown.visible = false;
      dropdown.position.x = -0.35;
      dropdown.position.y = this.height / 2 - 0.32;
      dropdown.position.z = 0.001;

      const btn = this.uilib.createBtn({
        map: btn_normal,
        text: "完成",
        width: 0.25,
        height: 0.1,
        textSize: 0.04,
        textColor: 0xafbbe3,
        radius: 0,
        stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        },
      });
      btn.addHoverEnterEvent((obj) => {});
      btn.addHoverExitEvent((obj) => {});
      btn.addClickEvent((obj) => {
        this.manager.interface.confirmCurve();
      });
      this.container.add(btn);
      this.uis2.push(btn);
      if (this.modelEditTypy !== "curve") btn.visible = false;
      btn.position.x = -0.42;
      btn.position.y = -0.23; //this.height / 2 - 0.45;
      btn.position.z = 0.001;
    }

    // 随机按钮
    {
      this.openToggleIcon = await this.manager.loadManager.loadTexture(
        openToggleIconPath
      );
      this.closeToggleIcon = await this.manager.loadManager.loadTexture(
        closeToggleIconPath
      );

      const btn = this.uilib.createBtn({
        map: this.randomEnable ? this.openToggleIcon : this.closeToggleIcon,
        text: "",
        color: "#ffffff",
        width: 0.2,
        height: 0.08,
        radius: 0,
      });
      btn.addClickEvent((obj) => {
        // 关闭
        if (this.randomEnable) {
          obj.material.map = this.closeToggleIcon;
        }
        // 开启
        else {
          obj.material.map = this.openToggleIcon;
        }
        this.randomEnable = !this.randomEnable;

        if (this.modelEditTypy === "matrix") this.updateMatrixArgs();
        else this.updateCurveArgs();
      });
      this.container.add(btn);
      btn.position.x = -0.35;
      btn.position.y = -0.23;
      btn.position.z = 0.001;

      const text = this.uilib.createText({
        text: "随机",
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "left",
      });
      this.container.add(text);
      text.position.y = -0.23;
      text.position.x = -0.6;

      this.randomUIs = [btn, text];
    }

    // tabcontrol
    {
      const matrixIcon = await this.manager.loadManager.loadTexture(
        matrixIconPath
      );
      const curveIcon = await this.manager.loadManager.loadTexture(
        curveIconPath
      );
      let array = [matrixIcon, curveIcon];
      const uiObjs = [];
      for (var i = 0; i < array.length; i++) {
        const tempContainer = this.uilib.createContainer({
          width: 0.125,
          height: 0.125,
          radius: 0.02,
          dragable: false,
          color: 0xa8b4db,
          map: array[i],
          opacity: 0.5,
        });
        uiObjs.push(tempContainer);
      }
      const tabControl = this.uilib.createTabControl({
        opacity: 0.0,
        selectColor: 0xffffff,
        width: 0.125,
        height: 0.28,
        radius: 0,
        axis: "verticle",
        gap: 0.02,
        uiObjs: uiObjs,
        defaultIndex: this.modelEditTypy === "matrix" ? 0 : 1,
        elementStateChangeColor: {
          normal: 0xa8b4db,
          hover: 0xffffff,
          click: 0x4f5670,
        },
      });
      this.container.add(tabControl);
      tabControl.addOnElementClickEvent((obj, index) => {
        // 切换模型编辑类型
        if (index === 0) {
          this.modelEditTypy = "matrix";

          for (var i = 0; i < this.uis1.length; i++) {
            this.uis1[i].visible = true;
          }
          for (var i = 0; i < this.uis2.length; i++) {
            this.uis2[i].visible = false;
          }

          this.randomUIs.forEach((ui) => {
            ui.position.y = -0.23;
          });
        } else if (index === 1) {
          this.modelEditTypy = "curve";
          for (var i = 0; i < this.uis1.length; i++) {
            this.uis1[i].visible = false;
          }
          for (var i = 0; i < this.uis2.length; i++) {
            this.uis2[i].visible = true;
          }

          this.randomUIs.forEach((ui) => {
            ui.position.y = this.height / 2 - 0.45;
          });
        }
        this.manager.interface.setModelLibType(this.modelEditTypy);
      });
      tabControl.position.x = -0.1;
      tabControl.position.y = 0.0;
      tabControl.position.z = 0.001;
    }

    // 搜索框
    {
      const container2 = this.uilib.createContainer({
        map: dropdownBg,
        opacity: 0.5,
        width: 0.3,
        height: 0.08,
        color: 0xffffff,
        radius: 0.0,
        dragable: false,
      });
      this.container.add(container2);
      container2.position.x = 0.925;
      container2.position.y = 0.265;
      container2.position.z = 0.001;

      const searchBtn = this.uilib.createBtn({
        map: searchIcon,
        text: "",
        color: "#A8B4DB",
        width: 0.06,
        height: 0.06,
        radius: 0,
        stateChangeColor: {
          normal: 0xa8b4db,
          hover: 0xffffff,
          click: 0x4f5670,
        },
      });
      searchBtn.addClickEvent((btn) => {
        this.onSearchBtnClick(btn);
      });
      searchBtn.position.x = -0.1;
      searchBtn.position.z = 0.001;
      container2.add(searchBtn);

      this.inputfiled = this.uilib.createInputField({
        textColor: "#afbbe3",
        textSize: 0.035,
        textLimit: 5,
        width: 0.22,
        height: 0.08,
        radius: 0.0,
        opacity: 0.1,
        align: "left",
      });
      this.inputfiled.position.x = 0.04;
      this.inputfiled.position.z = 0.001;
      container2.add(this.inputfiled);
    }

    // 模型库列表
    {
      // 模型库显示列表
      const layout = new VGridLayout();
      layout.setCellSize(new Vector2(0.23, 0.25));
      layout.setCountLimit(3);
      layout.setSpacing(new Vector2(0.02, 0.02));
      this.scrollview = this.uilib.createScrollViewGrid({
        renderOrder: 99999,
        opacity: 0.0,
        width: 0.75,
        height: 0.5,
        radius: 0,
        gridLayout: layout,
        sliderColor: 0xafbbe3,
        handleColor: 0x8993c3,
        sliderOpacity: 0.5,
        handleOpacity: 0.8,
        sliderExitState: "hide",
        sliderHeight: 0.02,
      });
      this.scrollview.addOnElementHoverEnterEvent((item) => {
        this.onHoverEnterScrollViewItem(item);
      });
      this.scrollview.addOnElementHoverExitEvent((item) => {
        this.onHoverExitScrollViewItem(item);
      });
      this.scrollview.position.x = 0.4;
      this.scrollview.position.y = -0.05;
      this.scrollview.position.z = 0.001;
      this.container.add(this.scrollview);

      // 一级目录结构 ，获取数据后就不会改变
      this.manager.interface.loadTopCatalog((data) => {
        this.createFirstCatalog(data);
      });

      // 返回上一级菜单按钮
      const btn = this.uilib.createBtn({
        width: 0.07,
        height: 0.07,
        radius: 0,
        color: 0xffffff,
        map: backIcon,
        stateChangeColor: {
          normal: 0xffffff,
          hover: 0x9bb6d5,
          click: 0x4f5670,
        },
        text: "",
      });
      btn.addClickEvent((obj) => {
        this.onClickBackBtn();
      });
      this.container.add(btn);
      btn.position.x = -0.08;
      btn.position.y = 0.26;
      btn.position.z = 0.001;
    }

    if (!this._visible) {
      this.closePanel();
    }
  }

  /**
   * 更新矩阵参数
   */
  updateMatrixArgs() {
    const row = this.matrixInputfileds[0].text * 1;
    const col = this.matrixInputfileds[1].text * 1;
    const dis = this.matrixInputfileds[2].text * 1;
    this.manager.interface.setMatrixArgs(row, col, dis, this.randomEnable);
  }

  /**
   * 更新曲线参数
   */
  updateCurveArgs() {
    const dis = this.curveInputfiled.text * 1;
    this.manager.interface.setCurveArgs(dis, this.curveType, this.randomEnable);
  }

  /**
   * 为模型库滚动视图添加单项
   * @param {*} data
   */
  async addModelItem(data) {
    const container = this.uilib.createBtn({
      text: "",
      opacity: 0.5,
      color: 0x4f5670,
      width: 0.22,
      height: 0.25,
      radius: 0.02,
    });
    container.addHoverEnterEvent((obj) => {});
    container.addHoverExitEvent((obj) => {});
    container.addClickEvent((obj) => {
      //  选中材质
      if (obj._scrollviewData)
        this.onClickModellibItem(obj._scrollviewData, obj._icon);
      else console.error("材质库列表错误，缺少数据");
    });
    container._scrollviewData = data;

    let tex = this.defaultIcon;
    if (data.screenshot) {
      tex = await this.manager.loadManager.loadTexture(
        data.screenshot.indexOf("/assets/") >= 0
          ? data.screenshot
          : window.base + "/" + data.screenshot
      );
    }
    const img = this.uilib.createImage({
      map: tex,
      width: 0.18,
      height: 0.18,
      radius: 0.01,
    });
    img.position.x = 0.001;
    img.position.y = 0.02;
    img.position.z = 0.001;
    container.add(img);
    container._icon = img;
    this.scrollview.setSomethingForLater(img);

    // 区分学生库还是标准库
    {
      let roleBg = new CircleGeometry(0.03, 24);
      let roleMat = new MeshBasicMaterial({
        color: 0x000000,
        side: DoubleSide,
        transparent: true,
      });
      let roleMesh = new Mesh(roleBg, roleMat);
      roleMesh.renderOrder = 9999999;
      roleMesh.position.z = 0.01;
      roleMesh.position.x = 0.04;
      roleMesh.position.y = 0.07;
      const text = this.uilib.createText({
        renderOrder: 99999999,
        text: data.role === "student" ? "学" : "标",
        textColor: 0xffffff,
        textSize: 0.03,
        font: "bold",
        align: "center",
        createdCB: (tex) => {
          this.scrollview.setSomethingForLater(text);
        },
      });
      roleMesh.add(text);
      container.add(roleMesh);
    }

    let str = data.name;
    if (!str) str = "";
    if (str.length > 7) {
      str = str.substring(0, 7) + "...";
    }

    const name = this.uilib.createText({
      text: str,
      textColor: 0xafbbe3,
      textSize: 0.025,
      font: "bold",
      align: "left",
      createdCB: (tex) => {
        this.scrollview.setSomethingForLater(name);
      },
    });
    name.position.x = -0.09;
    name.position.y = -0.09;
    name.position.z = 0.001;
    container.add(name);

    this.scrollview.addContent(container);
  }

  /**
   * 设置选中模型库的图标
   * @param {*} texture 传入图片或base64字符串，如果为null则使用默认图标
   */
  setSelectModelIcon(texture) {
    if (!texture) {
      texture = this.defaultIcon;
    }
    if (this.selectIcon) {
      this.selectIcon.material.map = texture;
      this.selectIcon.material.needsUpdate = true;
    }
  }

  /**
   * 设置显示 当前选中材质名称 的文字
   * @param {*} name
   */
  setSelectModelName(name) {
    if (this.selectName) {
      if (this.selectName.text === name) return;
      this.uilib.removeUI(this.selectName);
      this.selectName = null;
    }

    if (!name) {
      name = "";
    }
    if (name.length > 9) {
      name = name.substring(0, 9) + "...";
    }

    this.selectName = this.uilib.createText({
      text: name,
      textColor: 0xafbbe3,
      textSize: 0.035,
      font: "bold",
      align: "left",
    });
    this.container.add(this.selectName);
    this.selectName.position.x = -1.025;
    this.selectName.position.y = -0.23;
    this.selectName.position.z = 0.001;
  }

  /**
   * 设置显示默认材质
   */
  setDefault() {
    this.setSelectModelIcon();
    this.setSelectModelName("");
  }

  /**
   * 点击搜索按钮
   */
  onSearchBtnClick(obj) {
    const text = this.inputfiled.text;
    //  搜索模型
    this.manager.interface.loadModelData(text, (data) => {
      // 清除展示的模型库
      this.scrollview.clearContent();

      // 加载搜索结果
      for (var i = 0; i < data.length; i++) {
        this.addModelItem(data[i]);
      }
    });
  }

  /**
   * 点击模型库里的模型时触发
   * @param {*} data
   */
  onClickModellibItem(data, icon) {
    if (!data) return;

    // 加载选中的模型库项 并替换左侧大图标
    this.currentSelectData = data;
    this.setSelectModelName(data.name);
    this.setSelectModelIcon(icon.material.map);
    this.curSelectLeftIcon = icon.material.map;

    this.manager.interface.loadModelInfoById(data, (modeInfo) => {
      const ext =
        this.modelPrecision === "高"
          ? "_high.glb"
          : this.modelPrecision === "中"
          ? "_middle.glb"
          : "_low.glb";
      const url = window.base + "/" + modeInfo.path + ext;
      //console.log(modeInfo, url);
      const modelId = modeInfo._id;
      const modelName = modeInfo.name;
      const screenshot = modeInfo.screenshot;
      this.manager.interface.selectModelibItem(
        url,
        screenshot,
        modelId,
        modelName
      );
    });
  }

  /**
   * 当光标进入模型库列表时将光标所在的项信息传递到左侧的大图标中
   * @param {*} obj
   */
  onHoverEnterScrollViewItem(obj) {
    if (!obj || !obj._scrollviewData) {
      return;
    }

    this.curSelectLeftIcon = this.selectIcon.material.map;

    if (obj._icon) {
      this.setSelectModelIcon(obj._icon.material.map);
    }
    this.setSelectModelName(obj._scrollviewData.name);
  }

  /**
   * 当光标离开模型库列表时还原左侧的大图标
   * @param {*} obj
   */
  onHoverExitScrollViewItem(obj) {
    if (this.curSelectLeftIcon) {
      this.setSelectModelIcon(this.curSelectLeftIcon);
      this.curSelectLeftIcon = null;
    } else {
      this.setSelectModelIcon(null);
    }
    if (this.currentSelectData) {
      this.setSelectModelName(this.currentSelectData.name);
    } else {
      this.setSelectModelName("");
    }
  }

  /**
   * 创建一级目录结构
   * @param {*} data
   */
  createFirstCatalog(data) {
    let array = data;

    const tabControl = this.createTextTabControl(
      array,
      0.29,
      0.5,
      0.29,
      0.08,
      7,
      "verticle",
      (clickData) => {
        //  清除展示的模型库
        this.scrollview.clearContent();

        // 点击一级目录
        this.createOtherCatalog(clickData._id);

        this.clickCatalogStack = [];
      }
    );

    tabControl.position.x = 0.927;
    tabControl.position.y = -0.05;
    tabControl.position.z = 0.001;
    this.container.add(tabControl);

    // 默认显示第一个节点的二级目录
    if (array && array[0] && array[0]._id) {
      this.createOtherCatalog(array[0]._id);
    }
  }

  /**
   * 点击返回上一层目录按钮
   */
  onClickBackBtn() {
    // if (!this.currenSelectCatalogData || !this.currenSelectCatalogData.parentID)
    //   return;

    if (this.clickCatalogStack.length === 0) return;

    const id = this.clickCatalogStack.pop();

    this.createOtherCatalog(id);
  }

  /**
   * 创建二级或三级..目录菜单
   * @param {*} data
   */
  createOtherCatalog(id) {
    if (!id) return;

    this.manager.interface.loadOneCatalog(id, (data) => {
      // 清除上一个目录
      if (this.otherCatalogContorl) {
        this.uilib.removeUI(this.otherCatalogContorl);
        this.otherCatalogContorl = null;
      }
      //  清除展示的模型库
      this.scrollview.clearContent();

      const catalogs = []; // 目录
      const models = []; // 模型
      for (var i = 0; i < data.length; i++) {
        if (data[i].type === "catalog") {
          catalogs.push(data[i]);
        } else {
          models.push(data[i]);
        }
      }

      // 加载子目录
      if (catalogs.length > 0) {
        const tabControl = this.createTextTabControl(
          catalogs,
          0.7,
          0.08,
          0.18,
          0.08,
          4,
          "horizontal",
          (clickData) => {
            // 点击二级目录
            this.createOtherCatalog(clickData._id);

            this.clickCatalogStack.push(clickData.parentID);
          }
        );

        tabControl.position.x = 0.38;
        tabControl.position.y = 0.26;
        tabControl.position.z = 0.01;
        this.container.add(tabControl);
        this.otherCatalogContorl = tabControl;
      }

      // 加载模型页
      if (models.length > 0) {
        for (var i = 0; i < models.length; i++) {
          this.addModelItem(models[i]);
        }
      }
    });
  }

  /**
   * 创建目录tabcontrol
   * @param {*} datas
   * @param {*} width
   * @param {*} height
   * @param {*} textWidth
   * @param {*} textHeight
   * @param {*} textLimit
   * @param {*} axis
   * @returns
   */
  createTextTabControl(
    datas,
    width,
    height,
    textWidth,
    textHeight,
    textLimit, // 文字长度限制，超过这个长度会显示...
    axis,
    clickCB // 带一个参数的回调函数，参数为当前点击的目录数据
  ) {
    const uiObjs = [];
    let tabControl = null;
    for (var i = 0; i < datas.length; i++) {
      const container = this.uilib.createContainer({
        width: textWidth,
        height: textHeight,
        radius: 0.0,
        color: 0xffffff,
        opacity: i === 0 ? 0.2 : 0.1,
        dragable: false,
      });

      container._tabControlData = datas[i];

      let str = datas[i].name;
      if (str.length > textLimit) str = str.substring(0, textLimit - 1) + "...";
      const text = this.uilib.createText({
        text: str,
        textColor: 0xafbbe3,
        textSize: 0.04,
        font: "bold",
        align: "left",
        createdCB: (tex) => {
          if (tabControl) {
            tabControl.setSomethingForLater(text);
          }
        },
      });
      container.add(text);
      text.position.x = -textWidth / 2 + 0.01;
      uiObjs.push(container);
    }

    tabControl = this.uilib.createTabControl({
      opacity: 0.5,
      color: 0x0b0c0c,
      selectColor: 0xffffff,
      width: width,
      height: height,
      radius: 0,
      axis: axis,
      gap: 0.01,
      uiObjs: uiObjs,
      defaultIndex: 0,
      responseForSelectd: axis === "horizontal" ? true : false,
      elementStateChangeOpacity: {
        normal: 0.1,
        hover: 0.2,
      },
    });
    // 增加光标进入元素事件，设置后会覆盖默认的光标进入事件，可选
    tabControl.addOnElementHoverEnterEvent((obj) => {
      // 不建议在这里修改颜色，会覆盖选中项
    });
    // 增加光标离开元素事件，设置后会覆盖默认的光标离开事件，可选
    tabControl.addOnElementHoverExitEvent((obj) => {});
    // 增加点击事件
    tabControl.addOnElementClickEvent((obj, index) => {
      //console.log("点击", obj._tabControlData);
      if (obj._tabControlData) {
        if (clickCB) clickCB(obj._tabControlData);
      }
    });
    return tabControl;
  }

  closePanel() {
    super.closePanel();

    // 取消当前模型选中状态
    this.manager.sceneManager.detach();
    this.manager.vrManager.selectHiarerchyNodes([]);

    this.manager.interface.setClickMode(0); // 切换到默认模式
  }

  show() {
    super.show();

    this.manager.interface.setClickMode(6); // 切换到模型库模式
  }
}
